import React from 'react'

import FeatureCard from './Components/FeatureCard/FeatureCard'

const IMAGE_BASE = '/assets/ai_sub_landing/create_with_ai'

function CreateWithAi() {
  return (
    <section className="create-with-ai" aria-labelledby="create-with-ai-title">
      <div className="create-with-ai__header">
        <h2 id="create-with-ai-title" className="create-with-ai__title cgt-heading-500">
          Create 3D Models with AI
        </h2>
        <p className="create-with-ai__subtitle cgt-body-lg">
          Get clean, usable 3D assets in seconds — from text prompts or images to production-ready models.
        </p>
      </div>
      <div className="create-with-ai__body">
        <div className="create-with-ai__row">
          <FeatureCard
            variant="image"
            title="Image to 3D"
            description={'Turn any image into a 3D model. Upload or generate a reference and CGTrader AI '
              + 'will convert it into a ready-to-use 3D asset.'}
            imageSrc={`${IMAGE_BASE}/image_to_3d.webp`}
            imageWidth={1000}
            imageHeight={460}
          />
          <FeatureCard
            variant="text"
            title="Text to 3D"
            description={'Turn simple text prompts into detailed 3D models in seconds. '
              + 'Describe what you need, and AI brings it to life.'}
            imageSrc={`${IMAGE_BASE}/text_to_3d.webp`}
            imageWidth={1000}
            imageHeight={449}
          />
        </div>
        <FeatureCard
          variant="enhance"
          title="Enhance 3D Model"
          description={'Edit your 3D model with advanced tools. Optimize topology, improve textures, '
            + 'segment different elements, and bring it to life with animation.'}
          imageSrc={`${IMAGE_BASE}/enhance_3d_model.webp`}
          imageWidth={1340}
          imageHeight={633}
        />
      </div>
    </section>
  )
}

export default CreateWithAi
